<script setup lang="ts">
import { computed, inject, ref } from 'vue'
import FilterWhenField from './FilterWhenField.vue'
import type { ScopeDescriptor } from '@/types/bbel-types'
import { BBEL_SCOPE_KEY, EMPTY_BBEL_SCOPE, type BbelScopeContext } from '@/views/builder/composables/bbel-context'
import { EDITED_SERVICE_KEY, type EditedServiceContext } from '@/views/builder/composables/edited-service-context'

const props = withDefaults(
  defineProps<{
    /** How many of the settings in the slot are authored. Filter when is counted here, not by the caller. */
    authoredCount?: number
  }>(),
  { authoredCount: 0 },
)

const editedService = inject<EditedServiceContext | undefined>(EDITED_SERVICE_KEY, undefined)
const scopeCtx = inject<BbelScopeContext | undefined>(BBEL_SCOPE_KEY, undefined)
const scope = computed<ScopeDescriptor>(() => scopeCtx?.value ?? EMPTY_BBEL_SCOPE)

const open = ref(false)

const filterWhen = computed({
  get: () => editedService?.value?.serviceFilterExpression ?? '',
  set: (expression: string) => {
    if (!editedService?.value) return
    editedService.value = { ...editedService.value, serviceFilterExpression: expression }
  },
})

const filterIsSet = computed(() => filterWhen.value.trim() !== '')
const count = computed(() => props.authoredCount + (filterIsSet.value ? 1 : 0))
</script>

<template>
  <div class="border-top mt-4 pt-2">
    <button
      type="button"
      class="btn btn-link text-secondary text-decoration-none px-0"
      :aria-expanded="open"
      @click="open = !open"
    >
      <i class="bi small me-1" :class="open ? 'bi-chevron-down' : 'bi-chevron-right'"></i>
      Advanced settings
      <span v-if="count" class="badge text-bg-secondary ms-1">{{ count }}</span>
    </button>
    <div v-if="open" class="mt-2">
      <slot />
      <FilterWhenField v-model="filterWhen" :scope="scope" />
    </div>
  </div>
</template>
